import { GetTermManualInput } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
import CarrierLogisticsWebServerClient from "../clients/CarrierLogisticsWebServerClient";
export function getTermManualService(param) {
    var termKey = param.termKey;
    return CarrierLogisticsWebServerClient.getTermManual(GetTermManualInput.clone({
        presignedUrlInputParameters: {
            s3ObjectKeys: [
                termKey
            ]
        }
    }));
}
export default getTermManualService;

//# sourceMappingURL=downloadTermManual.js.map